module.exports = __webpack_public_path__ + "img/star-icon.149a42b7.svg";